import React from 'react';
import logo from '../images/logo@2x.png';

const Logo = () => {
  return (
    <img className="logo" src={logo} alt="Lyrically Noted" />
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js